// Session Security Utility
// Prevents URL sharing between different browser tabs/windows

class SessionSecurity {
  constructor() {
    this.SESSION_ID_KEY = 'session_id';
    this.TAB_ID_KEY = 'tab_id';
    this.SESSION_TIMEOUT = 30 * 60 * 1000; // 30 minutes
  }

  // Generate unique session ID
  generateSessionId() {
    return `session_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
  }

  // Generate unique tab ID
  generateTabId() {
    return `tab_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
  }

  // Initialize session for current tab
  initializeSession() {
    // Get or create session ID (shared across tabs)
    let sessionId = sessionStorage.getItem(this.SESSION_ID_KEY);
    if (!sessionId) {
      sessionId = this.generateSessionId();
      sessionStorage.setItem(this.SESSION_ID_KEY, sessionId);
    }

    // Create unique tab ID (unique per tab)
    const tabId = this.generateTabId();
    sessionStorage.setItem(this.TAB_ID_KEY, tabId);

    return { sessionId, tabId };
  }

  // Validate if current tab is authorized
  isValidSession() {
    const sessionId = sessionStorage.getItem(this.SESSION_ID_KEY);
    const tabId = sessionStorage.getItem(this.TAB_ID_KEY);
    
    // If no session or tab ID, session is invalid
    if (!sessionId || !tabId) {
      return false;
    }

    // Check if user is logged in
    const user = localStorage.getItem('user');
    if (!user) {
      return false;
    }

    // Check session timeout
    const lastActivity = parseInt(localStorage.getItem('lastActivity') || Date.now());
    if (Date.now() - lastActivity > this.SESSION_TIMEOUT) {
      return false;
    }

    return true;
  }

  // Clear session data
  clearSession() {
    sessionStorage.removeItem(this.SESSION_ID_KEY);
    sessionStorage.removeItem(this.TAB_ID_KEY);
  }

  // Get current session info
  getSessionInfo() {
    return {
      sessionId: sessionStorage.getItem(this.SESSION_ID_KEY),
      tabId: sessionStorage.getItem(this.TAB_ID_KEY)
    };
  }
}

export default new SessionSecurity();
